import React, { useMemo } from 'react';
import { TableCell, Typography, Skeleton } from '@mui/material';
import { useInsightEndpointQuery } from '@/features/properties/propertiesApi';

export const BranchCellData = ({ branchId, ...params }) => {
	const {
		data: branchData,
		isLoading,
		isError,
	} = useInsightEndpointQuery({
		endpoint: '/Branch/List',
	});

	const branch = branchData?.Results.find((item) => item.Id === branchId);
	const branchName = branch?.Name || '';

	if (isLoading) {
		return <Skeleton variant='text' width={120} />;
	}
	return <Typography sx={{ color: params?.color }}>{branchName}</Typography>;
};

export const BranchCell = ({ branchId, ...params }) => {
	return (
		<TableCell>
			<BranchCellData branchId={branchId} {...params} />
		</TableCell>
	);
};
